// extracted by mini-css-extract-plugin
module.exports = {"crawler_result_page":"Result_crawler_result_page__a2QGk","main":"Result_main__1vMqk","itemContainer":"Result_itemContainer__fGlA2","backButton":"Result_backButton__3sLoJ"};